export class LibraryFolderMember {
  constructor(memberData) {
    this.uuid = memberData.uuid || memberData.user_uuid
    this.name = memberData.name || memberData.user_name
    this.role = memberData.role
    this.email = memberData.email || memberData.user_email
  }
}

export class LibraryFolderMembersList {
  constructor(membersData) {
    if (Array.isArray(membersData)) {
      this.members = membersData.map((memberData) => new LibraryFolderMember(memberData))
      return
    }
    if (membersData instanceof LibraryFolderMembersList) {
      this.members = membersData.getFolderMembers()
      return
    }
    this.members = []
  }
  hasMembers() {
    return !!this.members.length
  }
  getFolderOwner() {
    if (!this.hasMembers()) {
      return null
    }
    return this.members.find((member) => {
      return member.role === 'owner'
    }) || null
  }
  getFolderMembers() {
    return this.members
  }
}
